import {Validators} from '../../../utils/validators';
import {FormModel} from '../../../components/Form';

export const FirstTimeChangePasswordForm = (strings: any): FormModel[] => {
  const passwordValidators = [{check: Validators.validateMandatoryField}, {check: Validators.validatePassword}];

  return [
    {
      autoFocus: true,
      label: strings.old_password_text,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'password',
      variant: 'outlined',
      placeholder: '',
      field: 'oldPassword',
      validators: [{check: Validators.validateMandatoryField}],
      sx: {mb: 2},
      responsive: {xs: 12},
      required: true,
    },
    {
      label: strings.new_password_text,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'password',
      variant: 'outlined',
      placeholder: '',
      field: 'newPassword',
      validators: passwordValidators,
      sx: {mb: 2},
      responsive: {xs: 12},
      required: true,
    },
    {
      label: strings.confirm_password_text,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'password',
      variant: 'outlined',
      placeholder: '',
      field: 'confirmPassword',
      validators: passwordValidators,
      responsive: {xs: 12},
      required: true,
    },
  ];
};
